<template>
  <l-popup icon="bars" placement="right-start" class="text-lg">
    <div class="text-sm flex flex-wrap w-64 select-none pb-2 pt-2">
      <router-link
        v-close-popover
        :to="a.to"
        class="px-4 py-2 w-full hover:bg-blue-100 hover:cursor-pointer"
        :class="{'border-b border-gray-light': a.border }"
        v-for="(a, i) in menu_sub"
        :key="i"
      >
        <font-awesome-icon :icon="a.icon" :class="a.class" />
        <label class="ml-2 select-none hover:cursor-pointer">{{$t(a.text)}}</label>
      </router-link>
    </div>
  </l-popup>
</template>

<script>
import LPopup from "@/components/LPopup";
import { VClosePopover } from "v-tooltip";

export default {
  name: "LMenu",
  components: {
    LPopup
  },
  directives: {
    "close-popover": VClosePopover
  },
  data() {
    return {
      menu_sub: [
        {
          icon: "network-wired",
          class: "text-pastel-purple",
          text: "sensors",
          to: "/", 
        },
        {
          icon: "map",
          class: "text-pastel-red",
          text: "mapmenu",
          to: "/sensorsmap"
        },  
        {
          icon: "map",
          class: "text-pastel-red",
          text: "sensorstatusmenu",
          to: "/sensorstatus",  
          border: true
        },
        {
          icon: "file-export",
          class: "text-blue-400",
          text: "observations",
          to: "/observations",
          border: true
        },
        {
          icon: "network-wired",
          class: "text-pastel-purple",
          text: "providers",
          to: "/management/providers"
        },
        {
          icon: "network-wired",
          class: "text-pastel-purple",
          text: "datalevels", 
          to: "/management/datalevels"
        },
        {
          icon: "network-wired",
          class: "text-pastel-purple",
          text: "components",
          to: "/management/components"
        },
        {
          icon: "network-wired",
          class: "text-pastel-purple",
          text: "units",
          to: "/management/units"
        },
        {
          icon: "flag",
          class: "text-red-400",
          text: "qualitycontrol",
          to: "/qualitycontrol/qcsensors"
        },
        {
          icon: "arrow-alt-circle-down",
          class: "text-green-400",
          text: "datadownload",
          to: "/datadownload"
        },
        {
          icon: "exclamation-triangle",
          class: "text-orange-400",
          text: "aboutDataMap",
          to: "/about"
        }           
      ]
    };
  }
};
</script>

